import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  eye_icon,
  green_icon,
  password_icon,
  red_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import apiRequest from "../redux/api/apiRequest";
import {
  useAddAdminMutation,
  useLazyAdminStatusQuery,
  useLazyDeleteAdminQuery,
  useLazyViewAdminQuery,
  useListAdminMutation,
  useListRoleMutation,
  useUpdateAdminMutation,
} from "../redux/api/api";
import { EMAIL, PASS } from "../redux/api/Constants";
import { toast } from "react-toastify";
import { get, post } from "../../Services/ApiHandler";
import { URL } from "../../Services/Constant";
import useSearch from "../../components/Searchbox/useSearch";
import Header from "../../components/Header";

const UserList = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const givenuser = JSON.parse(localStorage.getItem("user_details"));
  const token = localStorage.getItem("token");
  const [deletePopup, setDeletePopup] = useState("");
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [visible, setVisible] = useState(false);
  const [rolesList, setRoleslist] = useState([]);
  const [rolesLists, setRoleslists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const searchVal = useSearch(search);
  const [check, setCheck] = useState(false);
  const [admindetails, setAdminDetails] = useState({
    id: "",
    name: "",
    email: "",
    role_id: "",
    knf_role_id: "",
    mobile: "",
    password: "",
    password_confirmation: "",
  });
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [addAdmin] = useAddAdminMutation();
  const [viewAdmin] = useLazyViewAdminQuery();
  const [listAdmin] = useListAdminMutation();
  const [adminStatus] = useLazyAdminStatusQuery();
  const [deleteAdmin] = useLazyDeleteAdminQuery();
  const [updateAdmin] = useUpdateAdminMutation();
  const [listRole] = useListRoleMutation();

  const [shake, setShake] = useState(false);

  const handleStatus = async (id) => {
    const res = await apiRequest(adminStatus, id);
    if (res?.status == "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const handleDelete = async () => {
    const res = await apiRequest(deleteAdmin, deletePopup);
    if (res?.status == "success") {
      toast.success(res?.message);
      setDeletePopup("");
      getList();
    }
  };

  const AdminView = async (id, type) => {
    setLoading(true);
    const res = await apiRequest(viewAdmin, id);
    if (res?.status == "success") {
      setPopup(type);
      let data = res?.admin_data;
      // setRoleslist(res?.roles);
      Object.keys(admindetails).forEach((item) => {
        // console.log(item);
        setAdminDetails((prevState) => ({
          ...prevState,
          is_email_verified: data?.is_email_verified,
          [item]:
            item == "name"
              ? data?.name
              : item == "email"
                ? data?.email
                : item == "role_id"
                  ? data?.role?.id
                  : item == "knf_role_id"
                    ? data?.knf_role?.id
                    : item == "mobile"
                      ? data?.mobile
                      : item == "id"
                        ? data?.id
                        : "",
        }));
      });
      setEditMode(1);
      setPopup(type);
    }
    setLoading(false);
    console.log(res);
  };

  const getList = async (search) => {
    const formdata = new FormData();
    formdata.append("rows", 10);
    formdata.append("search", search ? search : "");
    formdata.append("order", "desc");
    formdata.append("page", page);
    const res = await apiRequest(listAdmin, formdata);
    if (res?.status == "success") {
      setList(res?.lists);
      setPagination(res?.pagination_meta);
    }
  };

  const getRolesList = async () => {
    const formdata = new FormData();
    formdata.append("rows", 10);
    formdata.append("search", "");
    formdata.append("order", "desc");
    formdata.append("type", 1);
    const res = await apiRequest(listRole, formdata);
    if (res?.status == "success") {
      // let List = res?.roles
      // let List = res?.lists?.filter((item) => {
      //   if (item?.status == 1) {
      //     return true;
      //   }
      // });
      setRoleslist(res?.lists);
    }
  };

  const getSuperAdminRolesList = () => {
    post(URL.SUPER_ADMIN_ROLES, {})
      .then((res) => {
        setRoleslist(res?.knf_roles);
        setRoleslists(res?.camera_roles);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    if (
      givenpermissions?.includes("CAN-List-ADMINS") ||
      givenpermissions?.includes("CAN-List-KNF_ADMIN")
    ) {
      getList();
    }
    // getRolesList();
    getSuperAdminRolesList();
  }, []);

  const validatePassword = (pass) => {
    if (!pass) return "Enter password";
    if (!/[A-Z]/.test(pass)) return "Password must contain uppercase letters";
    if (!/[a-z]/.test(pass)) return "Password must contain lowercase letters";
    if (!/[0-9]/.test(pass)) return "Password must contain numbers";
    if (pass.length < 8) return "Password must be at least 8 characters";
    if (!/[!*@#%&()^~{}]/.test(pass))
      return "Password must contain a special character";
    return "";
  };

  const AdminAdd = async () => {
    if (
      !admindetails?.name ||
      admindetails?.mobile?.length < 8 ||
      !admindetails?.email ||
      (!admindetails?.role_id && !admindetails?.knf_role_id) ||
      !admindetails?.email.match(EMAIL)
    ) {
      setError(true);
      setShake(true);

      setTimeout(() => {
        setShake(false);
      }, 500);
      return;
    }
    // if (!editMode) {
    //   if (
    //     admindetails?.password?.length < 8 ||
    //     admindetails?.password_confirmation?.length < 8 ||
    //     !admindetails?.password?.match(PASS) ||
    //     admindetails?.password != admindetails?.password_confirmation
    //   ) {
    //     setError(true);
    //     return;
    //   }
    // }
    setError(false);
    const formdata = new FormData();
    formdata.append("name", admindetails?.name);
    formdata.append("email", admindetails?.email);
    if (admindetails?.role_id) {
      formdata.append("role_id", admindetails?.role_id);
    } else {
      formdata.append("role_id", "");
    }

    if (admindetails?.knf_role_id) {
      formdata.append("knf_role_id", admindetails?.knf_role_id);
    } else {
      formdata.append("knf_role_id", "");
    }

    formdata.append("mobile", admindetails?.mobile);
    // formdata.append("password", admindetails?.password);
    // formdata.append(
    //   "password_confirmation",
    //   admindetails?.password_confirmation
    // );
    if (editMode) {
      formdata.append("admin_id", admindetails?.id);
    }
    setLoader(true);
    const res = await apiRequest(editMode ? updateAdmin : addAdmin, formdata);
    setLoader(false);
    if (res?.status == "success") {
      toast.success(res?.message);
      setPopup("");
      setAdminDetails({});
      setEditMode(false);
      getList();
    }
  };

  useEffect(() => {
    getList(searchVal);
  }, [searchVal, page]);

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    setAdminDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: " Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return (
            <div>
              <p>{value}</p>
              <div className="d-flex ac-jc mt-2 gap-2">
                <img
                  src={row?.original?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {row?.original?.is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            </div>
          );
        },
      },
      {
        Header: "KNF WAS@SG Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          return <p>{value?.name ? value?.name : "-"}</p>;
        },
      },
      {
        Header: "AIWARE Role",
        accessor: "knf_role",
        Cell: ({ value, row }) => {
          return <p>{value?.name ? value?.name : "-"}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          let user = JSON.parse(localStorage.getItem("user_details") ?? "{}");
          let mainUser = row?.original?.email == "bala@knfepl.com";
          let loginUser = row?.original?.id === user?.id;
          return (
            <div>
              <fieldset
                disabled={
                  (givenuser?.role?.id && row?.original?.role?.id) ||
                  (givenuser?.knf_role?.id && row?.original?.knf_role?.id)
                    ? false
                    : true
                }
                className={`${
                  (givenuser?.role?.id && row?.original?.role?.id) ||
                  (givenuser?.knf_role?.id && row?.original?.knf_role?.id)
                    ? ""
                    : "opacity-50"
                }`}
              >
                <button
                  onClick={() => {
                    if (
                      givenpermissions?.includes("CAN-Status-ADMINS") ||
                      givenpermissions?.includes("CAN-Status-KNF_ADMIN")
                    ) {
                      handleStatus(row.original.id);
                    }
                  }}
                  disabled={mainUser || loginUser}
                  className={`border-0 ms-2 cust-btn `}
                >
                  {value == 1 ? (
                    <img
                      className={`toggle-btn ${
                        givenpermissions?.includes("CAN-Status-ADMINS") ||
                        givenpermissions?.includes("CAN-Status-KNF_ADMIN")
                          ? ""
                          : "opacity-25"
                      }`}
                      src={toggle_on}
                    />
                  ) : (
                    <img
                      className={`toggle-btn ${
                        givenpermissions?.includes("CAN-Status-ADMINS") ||
                        givenpermissions?.includes("CAN-Status-KNF_ADMIN")
                          ? ""
                          : "opacity-25"
                      }`}
                      src={toggle_off}
                    />
                  )}
                </button>
              </fieldset>
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          const mainUser = row?.original?.email == "bala@knfepl.com";
          return (
            <React.Fragment>
              <fieldset
                disabled={
                  (givenuser?.role?.id && row?.original?.role?.id) ||
                  (givenuser?.knf_role?.id && row?.original?.knf_role?.id)
                    ? false
                    : true
                }
                className={`${
                  (givenuser?.role?.id && row?.original?.role?.id) ||
                  (givenuser?.knf_role?.id && row?.original?.knf_role?.id)
                    ? ""
                    : "opacity-50"
                }`}
              >
                <div className="d-flex ac-jc">
                  {givenpermissions?.includes("CAN-View-ADMINS") ||
                  givenpermissions?.includes("CAN-View-KNF_ADMIN") ? (
                    <button
                      onClick={() => {
                        // setPopup("view");
                        AdminView(row.original.id, "view");
                      }}
                      className="cust-btn "
                    >
                      <img src={view_icon} alt="" className="mx-2 edit-btn " />
                    </button>
                  ) : null}
                  {givenpermissions?.includes("CAN-Edit-ADMINS") ||
                  givenpermissions?.includes("CAN-Edit-KNF_ADMIN") ? (
                    <button
                      onClick={() => {
                        AdminView(row.original.id, "edit");
                      }}
                      className={`cust-btn ${givenuser?.id == row.original.id || mainUser ? "opacity-50" : ""}`}
                      disabled={givenuser?.id == row.original.id || mainUser}
                    >
                      <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                    </button>
                  ) : null}
                  {/* {givenpermissions?.includes("CAN-Delete-ADMINS") ||
                  givenpermissions?.includes("CAN-Delete-KNF_ADMIN") ? (
                    <button
                      // onClick={() => setDeletePopup(true)}
                      onClick={() => setDeletePopup(row.original.id)}
                      className={`cust-btn ${givenuser?.id == row.original.id ? "opacity-50" : ""}`}
                      disabled={givenuser?.id == row.original.id}
                    >
                      <img
                        src={delete_icon}
                        alt=""
                        className="mx-2 edit-btn "
                      />
                    </button>
                  ) : null} */}
                </div>
              </fieldset>
            </React.Fragment>
          );
        },
      },
    ],
    [page],
  );

  // console.log("check", check);

  return (
    <div className="dashRightView home_section">
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.3)", // 👈 semi-transparent black
            zIndex: 1050, // above other elements
          }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="d-flex ac-jb">
        <Header type={"Admin List"} />
        {givenpermissions?.includes("CAN-Add-ADMINS") ||
        givenpermissions?.includes("CAN-Add-KNF_ADMIN") ? (
          <button
            onClick={() => setPopup(true)}
            // onClick={() => setPopup("add")}
            className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
          >
            {" "}
            + Add KNF Admin
          </button>
        ) : null}
      </div>

      <div className="d-flex ac-jb mt-2 ">
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  mb-0 ">
            Total Count :
          </h4>
          <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
            {list?.length}
          </h4>
        </div>
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 mt-1 ms-3">
            Search
          </h4>
          <input
            type="text"
            className="input-pop ps-2"
            placeholder=" Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>
      {popup && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                {popup == "view"
                  ? "View Admin"
                  : popup == "edit"
                    ? "Edit Admin"
                    : "Add Admin"}
              </h2>
              <button
                onClick={() => {
                  if (editMode) {
                    setEditMode(false);
                  }
                  setPopup("");
                  setAdminDetails({});
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Name<span className="text-danger">*</span>
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Name"
              name="name"
              onChange={(e) => {
                handleUpdate(e);
              }}
              value={admindetails?.name}
              disabled={popup == "view" ? true : false}
            />
            {error && !admindetails?.name && (
              <p className="err">Enter Your Name</p>
            )}
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Phone Number (Singapore)<span className="text-danger">*</span>
            </h4>
            <input
              type="number"
              className="input-pop ps-2 w-100"
              placeholder="Phone Number (Singapore)"
              name="mobile"
              onChange={(e) => {
                if (e.target.value?.length <= 8) {
                  handleUpdate(e);
                }
              }}
              value={admindetails?.mobile}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 8))}
              disabled={popup == "view" ? true : false}
            />
            {error && admindetails?.mobile?.length < 8 && (
              <p className="err">Enter Valid Phone Number (Singapore)</p>
            )}
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Email<span className="text-danger">*</span>
            </h4>
            <input
              type="email"
              className="input-pop ps-2 w-100"
              placeholder=" Email Address"
              name="email"
              onChange={(e) => {
                handleUpdate(e);
              }}
              value={admindetails?.email}
              disabled={
                popup == "view" || admindetails?.is_email_verified == 1
                  ? true
                  : false
              }
            />
            {editMode && (
              <div className="d-flex ac-je mt-2 gap-2">
                <img
                  src={admindetails?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {admindetails?.is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            )}
            {error &&
              (!admindetails?.email || !admindetails?.email.match(EMAIL)) && (
                <p className="err">Enter Valid Email</p>
              )}
            {givenuser?.role?.guard_name == "admin" && (
              <>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  KNF WAS@SG Roles
                </h4>
                <select
                  className="input-pop ps-2 w-100"
                  name="role_id"
                  onChange={(e) => {
                    handleUpdate(e);
                  }}
                  value={admindetails?.role_id}
                  disabled={popup == "view" ? true : false}
                >
                  <option value={""}> -- Select --</option>
                  {rolesList?.map((item) => {
                    return (
                      <option value={item?.id} key={item?.id}>
                        {" "}
                        {item?.name || item?.display_name}
                      </option>
                    );
                  })}
                </select>
              </>
            )}
            {givenuser?.knf_role?.guard_name == "admin" && (
              <>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  AIWARE Roles
                </h4>
                <select
                  className="input-pop ps-2 w-100"
                  name="knf_role_id"
                  onChange={(e) => {
                    handleUpdate(e);
                  }}
                  value={admindetails?.knf_role_id}
                  disabled={popup == "view" ? true : false}
                >
                  <option value={""}> -- Select --</option>
                  {rolesLists?.map((item) => {
                    return (
                      <option value={item?.id} key={item?.id}>
                        {" "}
                        {item?.name || item?.display_name}
                      </option>
                    );
                  })}
                </select>
              </>
            )}
            {error && !admindetails?.role_id && !admindetails?.knf_role_id && (
              <p className="err mt-1">
                {givenuser?.role?.guard_name == "admin" &&
                givenuser?.knf_role?.guard_name == "admin"
                  ? " Select Your KNF WAS@SG Role or AIWARE Roles"
                  : givenuser?.role?.guard_name == "admin"
                    ? " Select Your KNF WAS@SG Role"
                    : givenuser?.knf_role?.guard_name == "admin"
                      ? " Select Your AIWARE Roles"
                      : " Select Your Role"}
                <span className="text-danger">*</span>
              </p>
            )}

            {givenuser?.knf_role?.guard_name == "admin" && (
              <div className="d-flex ac-js ">
                <input
                  type="checkbox"
                  className="input-box mt-2 w-5"
                  style={{
                    accentColor: "#852e59",
                    marginTop: "15px",
                  }}
                  value={check}
                  onChange={() => setCheck(!check)}
                />
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3">
                  App Settings
                </h4>
              </div>
            )}
            {popup != "view" && (
              <div>
                <div className="d-flex ac-jc">
                  <button
                    onClick={() => {
                      AdminAdd();
                    }}
                    className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${shake ? "shake-btn" : ""}`}
                  >
                    {loader ? (
                      <div
                        className="spinner-border spinner-border-sm "
                        role="status"
                        style={{ marginRight: "5px" }}
                      ></div>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setDeletePopup("")} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  handleDelete();
                  setDeletePopup(false);
                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default UserList;
